import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GraphApiModule } from "@content-platform/web-angular-administration-shared-data-access-graph-api";
import { DisplayNamePipe, UserProfilePipe, ObjToArrayPipe, SearchPipe, SortPipe, PhoneNumberPipe, TruncatePipe, FilterWithPipe, MinutesSecondsPipe, SortByRelevancePipe, HighlightPipe, FileNamePipe, MillisecHhmmssPipe, CommasPipe, PixelsPipe, MonthDayYearPipe, LocalTimePipe, FormatBytesPipe, FirstThenLastNamePipe, WithLoadingPipe, DynamicSearchFilterPipe, SortByOrderPipe } from "./pipes";
import * as i0 from "@angular/core";
const pipes = [
    DisplayNamePipe,
    UserProfilePipe,
    ObjToArrayPipe,
    SearchPipe,
    SortPipe,
    PhoneNumberPipe,
    TruncatePipe,
    FilterWithPipe,
    MinutesSecondsPipe,
    SortByRelevancePipe,
    HighlightPipe,
    FileNamePipe,
    MillisecHhmmssPipe,
    CommasPipe,
    PixelsPipe,
    FileNamePipe,
    MonthDayYearPipe,
    LocalTimePipe,
    FormatBytesPipe,
    FirstThenLastNamePipe,
    WithLoadingPipe,
    DynamicSearchFilterPipe,
    SortByOrderPipe
];
export class PipesModule {
    static { this.ɵfac = function PipesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PipesModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PipesModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, GraphApiModule] }); }
}
//# sourceMappingURL=pipes.module.js.map